<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import { Popover, PopoverContent, PopoverTrigger } from './Popover'

defineProps<{
    title: string
    description: string
}>()
</script>

<template>
    <Popover>
        <PopoverTrigger as-child>
            <InformationCircleIcon class="cursor-pointer mt-0.5 size-5 text-primary-800" />
        </PopoverTrigger>
        <PopoverContent align="end" side="top" :side-offset="-5">
            <h6 class="font-medium">{{ title }}</h6>
            <p>{{ description }}</p>
        </PopoverContent>
    </Popover>
</template>
